import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { imageUrl } from '../api/rooms'

export default function LandlordCard({ item, onEdit, onDelete }) {
  const navigate = useNavigate()
  const id = item.id ?? item.roomID
  const title = item.title ?? item.name ?? ''
  const city = item.city ?? item.location?.city ?? ''
  const district = item.district ?? item.location?.district ?? ''
  const priceAmt = item.price?.amount ?? item.priceAmount ?? ''
  const priceCur = item.price?.currency ?? item.priceCurrency ?? ''
  const priceUnit = item.price?.unit ?? item.priceUnit ?? ''
  const unitLabel = priceUnit === 'PerMonth' ? '/ month' : priceUnit === 'PerWeek' ? '/ week' : '/ night'
  const images = (Array.isArray(item.imageUrl) ? item.imageUrl : (item.images ?? [])).map(imageUrl)

  const goEdit = () => {
    navigate(`/bailleurs/${id}/edit`, { state: { room: item } })
  }

  return (
    <div className="rounded-2xl border border-blue-100 shadow-card bg-white overflow-hidden">
      <Link to={`/annonce/${id}`} className="block">
        {images?.length
          ? <img className="w-full h-40 object-cover" src={images[0]} alt={title} />
          : <img className="w-full h-40 object-cover" src="https://via.placeholder.com/800x450?text=Locapiol" alt={title} />
        }
      </Link>

      <div className="p-4">
        <h3 className="font-bold text-lg line-clamp-1">{title}</h3>
        <p className="text-muted">{district ? `${city} · ${district}` : city}</p>
        <p className="mt-2 font-extrabold">{priceAmt} {priceCur} <span className="text-sm text-muted">{unitLabel}</span></p>

        <div className="flex items-center gap-2 mt-3">
          <button className="px-3 py-1 rounded-lg border hover:bg-blue-50" onClick={goEdit}>Éditer</button>
          <button className="px-3 py-1 rounded-lg border text-red-600 hover:bg-red-50" onClick={()=>onDelete?.(id)}>Supprimer</button>
        </div>
      </div>
    </div>
  )
}
